<template lang="pug">

transition(name='result')

  #result(v-if="show" v-bind:class="{ isAuthor: isAuthor, isViewer: !isAuthor }")

    //- ****************************************
    //- TOP
    //- ****************************************

    //- REPLAY
    button.replay(
      v-if="isAuthor === true"
      v-on:click="toReplay"
    )
      .content
        replay-icon.icon
        .label {{ $t('result.btn_again') }}




    .top
      //- SWOOSH
      swoosh-icon.swoosh.head

      //- TITLE
      h2.title

        div(v-if="isAuthor === true")
          p {{ $t('result.title') }}

        div(v-if="isAuthor === false")
          p {{ $t('share.generic.title')[0] }}
          p {{ $t('share.generic.title')[1] }}


      //- FINISH TIME
      finish-time(v-bind:time="duration")

      //- PERCENTILE
      .percentile(
        v-if="isAuthor === true"
      )
        span {{ $t('result.percentile[0]') }}
        span.big
          img.bg(src="~assets/result/btn-blue.png")
          reveal-text(
            v-bind:text="percentile"
            v-bind:reveal="revealed"
          )
          span.percent %
        span {{ $t('result.percentile[1]') }}

      //- SHARE
      .label.share-content(
        v-if="isAuthor === true"
      ) {{ $t('result.share_content') }}



    //- ****************************************
    //- HERO (Leave space for canvas)
    //- ****************************************
    .hero


    //- ****************************************
    //- BOTTOM
    //- ****************************************
    .bottom

      h2.cta-copy(v-if="isAuthor === false") {{ $t('share.generic.subtitle') }}


      .buttons.buttons-two(v-if="isAuthor === true")

        button.draw(
          v-if="locale !== 'en'"
          v-on:click="toDraw"
        )
          //- img.bg(src="~assets/result/shoe-zoom-cta.png")
          .bg
          .content
            span {{ $t('result.btn_draw') }}

        button.buy(v-on:click="toBuy")
          //- img.bg(src="~assets/result/shoe-zoom-cta.png")
          .bg
          .content
            span {{ $t('result.btn_buy') }}


      .buttons.buttons-one(v-else)
        button.home(v-on:click="toHome")
          //- img.bg(src="~assets/result/shoe-zoom-cta.png")
          .bg
          .content
            span(v-if="username") {{ $t('share.named.cta') }}
            span(v-else) {{ $t('share.generic.cta') }}



      .tc-button(
        v-if="isAuthor === true && locale !== 'en'"
        v-on:click="toTc"
      )
        .icon
          span i
        .label
          span {{ $t('result.btn_tc') }}


    //- ****************************************
    //- OVERLAYS
    //- ****************************************
    //- share-cta(
    //-   v-bind:active="showShare"
    //-   v-on:tap="showShare = false"
    //- )

    tc(
      v-bind:active="showTc"
      v-on:close="showTc = false"
    )

</template>


<script>
import Vue from 'vue'
import {mapState, mapActions} from 'vuex'
import FinishTime from 'src/components/finish-time/FinishTime'
import RevealText from 'src/components/reveal-text/RevealText'

import SwooshIcon from 'src/assets/swoosh.svg'

import ShareBtnBg from 'src/assets/result/btn-share-bg.svg'
import ShareIcon from 'src/assets/result/ico-share.svg'

import ReplayIcon from 'src/assets/result/ico-replay.svg'

import {service as ShareService} from 'src/api/ShareService'
import {service as AnalyticsService} from 'src/api/AnalyticsService'

// import ShareCta from './ShareCta'
import Tc from 'src/components/tc/Tc'
import game from 'src/components/game/main'
import i18n from 'src/i18n'


let base
if (process.env.NODE_ENV === 'production') {
  base = require('src/../config').build.assetsPublicPath
} else {
  base = require('src/../config').dev.assetsPublicPath
}


export default {
  name: 'result',
  components: {
    SwooshIcon,
    ShareIcon,
    ReplayIcon,
    FinishTime,
    RevealText,
    ShareBtnBg,
    Tc
  },
  data () {
    return {
      // isAuthor: true, // DEBUG
      revealed: false,
      percentile: '00',
      showShare: false,
      showTc: false,
      show: false,
      anim: {
        text: false,
        button: false,
        time: false,
        share: false
      },
      locale: i18n.locale
    }
  },
  computed: {
    isAuthor () {
      return this.$route.params.isAuthor || false
    },
    ...mapState({
      // isAuthor: state=> state.route.params.isAuthor,
      total: state => state.game.ranking.total,
      username: state => state.route.query._name,
      duration: state => state.route.query._duration,
      gameLoaded: state => state.game.loading.completed,
      windowWidth: state=> state.browser.windowWidth,
      windowHeight: state=> state.browser.windowHeight
    })
  },

  mounted () {

    window.result = this

    // NO TIME, GO HOME
    if (this.duration === null) return this.toHome()


    // LOAD ONLY RESULT IMAGES
    const urls = [
      // require('src/assets/result/board.jpg'),
      require('src/assets/result/cloth.png'),
      require('src/assets/result/shoe-1.png'),
      require('src/assets/result/shoe-2.png'),
      require('src/assets/result/shoe-3.png'),
      require('src/assets/result/shoe-zoom-title1.png'),
      require('src/assets/result/shoe-zoom-title2.png'),
      require('src/assets/result/shoe-zoom-title3.png')
    ]
    for (let url in game.loader.assets) {
      if (urls.indexOf(url) < 0) {
        delete game.loader.assets[url]
      }
    }
    game.loader.start()


    // GET RANK IF IS AUTHOR
    if (this.isAuthor) {
      AnalyticsService.sendPageview('/results')
      this.getRank({time: this.duration, name: this.username})
        .then(()=> {
          this.revealed = true
          this.percentile = this.$store.state.game.ranking.percentile || 0
        })

      ShareService.setResultLink(this.duration, this.username)

    } else {
      AnalyticsService.sendPageview('/sharedResults')
      // SET WECHAT SHARE LINK
      ShareService.init().then(()=>{
        ShareService.setDefaultLink()
      })
    }


    if (this.gameLoaded) {
      this.show = true
      this.playSeq()
    }

    this.positionScene()

  },


  beforeDestroy: function() {
    game.raf.removeListener('tick', game.result.cloth.update)
  },


  methods: {
    // startResultAnimation() {
    //   game.renderer.setRenderResults(true)
    //   game.result.scene.colorBgResult()
    //   if (this.isAuthor) {
    //     setTimeout(() => { this.anim.text = true }, 1000)
    //     setTimeout(() => { this.anim.time = true }, 1500)
    //     setTimeout(() => { this.anim.share = true }, 0)
    //     setTimeout(() => {
    //       game.result.scene.animateIn()
    //         .then(()=> {
    //           game.renderer.setRenderGame(false)
    //         })
    //     }, 1000)
    //     setTimeout(() => { this.anim.button = true }, 1700)


    //   } else {
    //     setTimeout(() => { this.anim.text = true }, 1000)
    //     // setTimeout(() => { this.anim.time = true }, 1500)
    //     setTimeout(() => {
    //       game.result.scene.animateIn()
    //         .then(()=> {
    //           game.renderer.setRenderGame(false)
    //         })
    //     }, 1000)
    //     setTimeout(() => { this.anim.button = true }, 1600)
    //   }
    // },
    positionScene() {
      let pos = {
        x: 0,
        y: 0,
        z: 0
      }
      let scale = 1


      let aspectRatio = this.windowWidth / this.windowHeight
      // PORTRAIT
      if (aspectRatio < 13 / 9) {
        if (this.isAuthor) {
          pos.y = -this.windowHeight * 0.08
        } else {
          pos.y = -this.windowHeight * 0.06
        }

        scale = 0.93
        if (this.windowHeight <= 570) {
          scale = 0.75
        }

      // LANDSCAPE
      } else {
        pos.x = -10 + this.windowWidth * 0.25
        pos.y = this.windowWidth * 0.08
        scale = 0.8
      }

      game.result.scene.content.position.set(pos.x, pos.y, pos.z)
      game.result.scene.content.scale.setScalar(scale)
    },
    playSeq () {
      Vue.nextTick(()=> {
        game.raf.on('tick', game.result.cloth.update)
        game.renderer.setRenderResults(true)
        game.result.scene.colorBgResult()
        game.result.scene.animateIn()
          .then(()=> {
            game.renderer.setRenderGame(false)
          })
      })
    },
    toHome () {
      const link = `${window.location.origin}${base}`
      setTimeout(()=> {
        window.location = link
      }, 100)
    },
    toReplay () {
      if (this.isAuthor && this.gameLoaded) {
        AnalyticsService.sendEvent('button-replay', 'tap')
        // game.result.scene.animateOut()
        // this.$router.replace('race')
        window.location = window.location.origin + base

      } else {
        AnalyticsService.sendEvent('button-newgame', 'tap')
        this.toHome()
      }
    },
    toShare () {
      AnalyticsService.sendPageview('/shareCta')
      AnalyticsService.sendEvent('button-share', 'tap')
      this.showShare = true
      // this.$router.replace('shareCta')
    },
    toTc () {
      AnalyticsService.sendEvent('button-tc', 'tap')
      this.showTc = true
    },
    toDraw () {
      const link = 'https://www.nike.com/events-registration/event?id=82446&cp=cn_brs_080617_u_ZPS_RN_NRC_wc_BY_GC'
      AnalyticsService.sendEvent('button-draw', 'tap')
      setTimeout(()=> {
        window.location = link
      }, 100)
    },
    toBuy () {
      const link = 'http://store.nike.com/cn/zh_cn/pw/轻质-跑步-鞋类/8yzZntaZoi3?cp=cn_brs_080617_u_ZPS_RN_NRC_wc_BY_GC'
      AnalyticsService.sendEvent('button-buy', 'tap')
      setTimeout(()=> {
        window.location = link
      }, 100)
    },
    ...mapActions('game', ['getRank'])
  },
  watch: {
    gameLoaded (val) {
      if (val) {
        this.show = true
        this.playSeq()
      }
    },
    windowWidth (val) {
      this.positionScene()
    },
    windowHeight (val) {
      this.positionScene()
    }
  }
}
</script>

<style lang="sass" scoped>
@import "src/common.sass"


#result
  +full()
  +flex-center()
  text-align: center
  color: white
  text-transform: uppercase
  padding: $ui-padding
  padding: 14px
  font-weight: normal


h1, h2, h3
  font-weight: normal


button.replay
  position: absolute
  top: 0
  left: 0
  height: 50px
  min-width: 100px
  white-space: nowrap
  color: white
  font-size: 14px
  z-index: 100
  pointer-events: all


  .content
    +flex-center()
    flex-direction: row

  svg
    width: 16px
    height: 16px
    fill: white
    margin-right: 3px


// ******************************
// TOP
// ******************************

.top
  position: absolute
  top: 0
  left: 0
  right: 0
  margin: auto
  height: 45%
  +flex-center()
  // background: rgba(0, 0, 0, 0.2)

.swoosh
  height: 20px
  min-height: 20px
  fill: white
  margin: $ui-padding * 0.75 auto

.finish-time
  margin: $ui-padding - 4px auto

.title
  font-size: 16px
  white-space: pre-line

button
  cursor: pointer



// ******************************
// SHARE BUTTON
// ******************************
.share-btn
  position: relative
  margin: $ui-padding / 2
  color: white
  font-size: 0

  .bg
    height: 9vmin

  .content
    +full()
    +flex-center()
    flex-direction: row
    justify-content: flex-start
    padding-left: 14%

  .icon
    fill: white
    height: 3.5vmin

  .label
    font-size: 12px
    margin-left: 0.4em
    text-align: left
    white-space: nowrap



// ******************************
// HERO
// ******************************
.hero
  position: relative
  flex: 1
  width: 100%


// ******************************
// RESULT PERCENTILE
// ******************************
.percentile
  position: relative
  // height: 8vh
  margin: $ui-padding / 2 auto
  width: 100%
  white-space: nowrap

  span
    position: relative
    z-index: 2
    font-size: 16px
    color: white
    position: relative
    bottom: 2px
    z-index: 2

    &.big
      z-index: 1
      position: relative
      margin: 0px 4px
      font-style: normal

      span
        bottom: 0
        font-size: 36px

      img
        position: absolute
        height: 240%
        top: 50%
        left: 0
        transform: translate(-8%, -74%) skew(-15deg)

.share-content
  font-size: 16px
  color: white
  // margin: $ui-padding / 2 auto
  // font-weight: bold


// ******************************
// BOTTOM
// ******************************
.bottom
  position: absolute
  bottom: 0
  height: 20%
  width: 100%
  +flex-center()
  // background: rgba(0, 0, 0, 0.5)

.cta-copy
  font-size: 16px

.buttons
  position: relative
  margin: $ui-padding
  +flex-center()
  flex-direction: row

  button
    position: relative
    font-size: 0
    margin: 0 10px
    // width: 130px
    padding: 0 $ui-padding
    height: 40px
    transform: skew(-22deg)
    overflow: hidden

    .bg
      +full()
      // background: $cl-blue
      background: rgba(23, 72, 223, 1.00)

    .content
      +full()
      +flex-center()
      position: relative
      // padding: 10px 16px

      span
        color: white
        font-size: 16px
        white-space: nowrap



.tc-button
  color: white
  font-size: 10px
  margin: $ui-padding / 2
  white-space: nowrap
  +flex-center()
  flex-direction: row
  font-style: normal

  .icon
    font-size: 8px
    width: 12px
    height: 12px
    +flex-center()
    border: 1px solid white
    border-radius: 50%
    margin-right: 2px
    text-align: center







// ****************************************
//
// ANIMATION
//
// ****************************************
.result-enter-active
  transition: all 1.6s ease 0s

.result-enter
  opacity: 0

.result-leave-active
  transition: all 0.4s ease 0s
  opacity: 0








// ****************************************
//
// RESPONSIVE LANDSCAPE VERSION
//
// ****************************************
@media screen and (min-aspect-ratio: 13/9)

  #result
    flex-direction: row

  .top
    left: 0
    right: auto
    height: 100%
    width: 50%

  .bottom
    left: auto
    right: 0
    height: 40%
    width: 50%



</style>



// WEBPACK FOOTER //
// Result.vue?1b8d1d64